import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-full-screen-icon',
  templateUrl: 'full-screen-icon.component.html'
})
export class FullScreenIconComponent {
  constructor() {}
}
